import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { FindManyResult } from "@/core/common/resource-base/find-many-result.dto";
import { IRequest } from "@/interfaces/IRequest";
import { cloneDeep } from "lodash";
import { ProjectHasWarehouseDto } from "@/core/features/projects-have-warehouses/project-has-warehouse.dto";
import { CreateProjectHasWarehouseDto } from "@/core/features/projects-have-warehouses/create-project-has-warehouse.dto";
import { UpdateProjectHasWarehouseDto } from "@/core/features/projects-have-warehouses/update-project-has-warehouse.dto";

export class ProjectsHaveWarehousesResource extends ResourceBaseService<
  ProjectHasWarehouseDto,
  CreateProjectHasWarehouseDto,
  UpdateProjectHasWarehouseDto
> {
  protected EntityDto = ProjectHasWarehouseDto;
  protected CreateEntityDto = CreateProjectHasWarehouseDto;
  protected UpdateEntityDto = UpdateProjectHasWarehouseDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/projects-have-warehouses");
  }

  async getWarehouses(
    projectId: string,
    request: IRequest = {},
    includeArchived?: boolean
  ): Promise<FindManyResult<ProjectHasWarehouseDto>> {
    const req = cloneDeep(request);
    if (!req.join) req.join = [];
    if (!req.join.includes("warehouse")) {
      req.join.push("warehouse");
    }

    if (!req.filters) req.filters = {};
    Object.assign(req.filters, { projectId: projectId });

    if (req.search) {
      req.searchBy = ["warehouseId", "warehouse.name"];
    }

    if (!req.sortBy) {
      req.sortBy = "warehouse.name";
    }

    return this.findAll(req, includeArchived);
  }
}
